import React, { useContext } from "react";

import { useDeviceInfo, XLARGE } from "@swa-ui/browser";
import { PageGrid } from "@swa-ui/core";
import i18n from "@swa-ui/locale";
import { PlacementFactory } from "@swa-ui/placements";
import { classNames } from "@swa-ui/string";

import { ApplicationContext } from "../ApplicationContextProvider";
import styles from "./AppFooter.module.scss";

/**
 * The AppFooter component provides a horizontal footer which is specific to the SPA. This component may include
 * multiple links that can be rendered horizontally with a full bleed background.
 */

export const AppFooter = () => {
  const { site } = useContext(ApplicationContext);
  const { screenSize } = useDeviceInfo();

  return (
    <nav
      aria-label={i18n("AppFooter__BOTTOM_NAV_ARIA")}
      className={styles.background}
      data-test="appFooter"
    >
      <PageGrid
        className={classNames(styles.layout, styles.footer)}
        maxWidth={!(site === "mobile" && screenSize === XLARGE)}
      >
        <PlacementFactory className={styles.content} id="globalNavFooterBanner" />
      </PageGrid>
    </nav>
  );
};
AppFooter.displayName = "AppFooter";
